import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toJpg'
})
export class ToJpgPipe implements PipeTransform {
  transform(value: string): any {
    switch (value) {
      case 'jpg':
      case 'png':
      case 'gif':
        value = 'jpg';
        break;
      default:
        break;
    }

    return value;
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/pipes/to-jpg.pipe.ts